import labelInputMixin from "../_mixin";
export default {
  name: "commonCascader",
  mixins: [labelInputMixin],
  methods: {
    renderInput(h, data) {
      return h("el-cascader", data);
    }
  },
};
